import React, {Component} from 'react';

import ResponsiveLayout from '../../common/ResponsiveLayout';
import Tracker from '../../common/Tracker';
import api from "../../../api/api.js"

import emailIcon from "../../../img/ic-email.png";
import faxIcon from "../../../img/ic-fax.png";
import phoneIcon from "../../../img/ic-phone.png";
import webIcon from "../../../img/ic-website.png";
import facebookIcon from "../../../img/ic-facebook.png";
import twitterIcon from "../../../img/ic-twitter.png";
import shareIcon from "../../../img/ic-share.png";
import printIcon from "../../../img/ic-print.png";

import "../../../css/LocationDetail.css";

const CATEGORY = "location details";

const contactInfoIcons = {

    left:[{
        key: "url",
        icon: webIcon,
        formatUrl: (path) => {return path.match(/^http/) ? path : "http://" + path},
        format: (url) =>{ return url.replace(/http[s]?:\/\//, "") }
    }, {
        key: "phoneNumber",
        icon: phoneIcon,
        format: (input) => {return input},
        formatUrl: (path) => {return "tel:" + path}
    }, {
        key: "faxNumber",
        icon: faxIcon,
        format: (input) => {return input}
    }],
    right:[{
        key: "facebookPageId",
        icon: facebookIcon,
        formatUrl: (path) => {return "https://www.facebook.com/" + path},
        format: (path) => {return "Facebook"}
    }, {
        key: "twitterHandle",
        icon: twitterIcon,
        formatUrl: (path) => {return "https://www.twitter.com/" + path},
        format: (path) => {return "Twitter"}
    }]
}

class ContactInfoPanelDesktopLayout extends Component {
    onPrintClick = () => {
        Tracker.trackEvent(CATEGORY, "print click", "", "");
        window.print();
    }

    render() {
        return (
            <div>
                <div className="location-details-contact-container minPadded">
                    <div className="location-details-contact-container-left">
                        {contactInfoIcons.left.map((item) => {
                            if(this.props.location[item.key]){
                                return (
                                    <div className="location-details-contact-container-item" onClick={item.formatUrl ? this.props.openUrl.bind(null, item.formatUrl(this.props.location[item.key])) : null}>
                                        <img className="contactInfoItemIcon" src={item.icon} alt="contact icon"/>
                                        <div style={{marginLeft: "10px"}}>{item.format(this.props.location[item.key])}</div>
                                    </div>)
                            }
                            return null;
                        })}
                    </div>
                    <div className="location-details-contact-container-right">
                        <div className="location-details-contact-container-right-social">
                            {contactInfoIcons.right.map((item) =>{
                                if(this.props.location[item.key]){
                                    return (
                                        <div className="location-details-contact-container-item" onClick={item.formatUrl ? this.props.openUrl.bind(null, item.formatUrl(this.props.location[item.key])) : null}>
                                            <img className="contactInfoItemIcon" src={item.icon} alt="contact icon"/>
                                            <div style={{marginLeft: "10px"}}>{item.format(this.props.location[item.key])}</div>
                                        </div>)
                                }
                                return null;
                            })}
                        </div>
                        <div className="location-details-contact-container-right-actions">
                            <div className="actionCircle container vertical-center center" onTouchTap={this.onPrintClick}>
                                <img className="contactInfoActionIcon" src={printIcon} alt="print icon" />
                            </div>
                            {this.props.location.emailAddress ?
                                <div className="actionCircle container vertical-center center" onTouchTap={this.props.showContactCenterDialog}>
                                    <img className="contactInfoActionIcon" src={emailIcon} alt="email icon" />
                                </div>
                                :
                                null
                            }
                            <div className="actionCircle container vertical-center center" onTouchTap={this.props.showShareLocationDialog}>
                                <img className="contactInfoActionIcon" src={shareIcon} alt="contact icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class ContactInfoPanelMobileLayout extends Component {
    render() {
        return (
            <div className="location-details-contact-container minPadded">
                <div style={{marginTop: "-40px", zIndex: 1000}}>
                    <div className="location-details-contact-container-right-actions">
                        <div className="actionCircle container vertical-center center" onTouchTap={this.props.showContactCenterDialog}>
                            <img className="contactInfoActionIcon" src={emailIcon} alt="email icon" />
                        </div>
                        <div className="actionCircle container vertical-center center" onTouchTap={this.props.showShareLocationDialog}>
                            <img className="contactInfoActionIcon" src={shareIcon} alt="share icon" />
                        </div>
                    </div>
                    <div className="location-details-contact-container-left">
                        {contactInfoIcons.left.map((item, index) =>{
                            if(this.props.location[item.key]){
                                return (
                                    <div key={"contact-container-" + index} className="location-details-contact-container-item" onClick={item.formatUrl ? this.props.openUrl.bind(null, item.formatUrl(this.props.location[item.key])) : null}>
                                        <img className="contactInfoItemIcon" src={item.icon} alt="contact info icon"/>
                                        <div style={{marginLeft: "10px"}}>{item.format(this.props.location[item.key])}</div>
                                    </div>
                                )
                            }
                            return null;
                        })}
                        {contactInfoIcons.right.map((item) =>{
                            if(this.props.location[item.key]){
                                return (
                                    <div className="location-details-contact-container-item" onClick={item.formatUrl ? this.props.openUrl.bind(null, item.formatUrl(this.props.location[item.key])) : null}>
                                        <img className="contactInfoItemIcon" src={item.icon} alt="contact icon"/>
                                        <div style={{marginLeft: "10px"}}>{item.format(this.props.location[item.key])}</div>
                                    </div>)
                            }
                            return null;
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

class ContactInfoPanel extends Component {

    openUrl = (url) => {
        if (url) {
            if (url.match(/facebook/)) {
                Tracker.trackEvent(CATEGORY, "facebook click", "", "");
            } else if (url.match(/twitter/)) {
                Tracker.trackEvent(CATEGORY, "facebook click", "", "");
            } else if (url.match(/tel:/i)) {
                Tracker.trackEvent(CATEGORY, "telephone click", "", "");
                api.trackLocationClick(this.props.location.key, 'phone_clicks');
            } else {
                Tracker.trackEvent(CATEGORY, "web site click", "", "");
                api.trackLocationClick(this.props.location.key, 'website_clicks');
            }

            window.open(url, "_target=blank");
        }
    }

    render() {
        return (
            <ResponsiveLayout
                desktopLayout={ContactInfoPanelDesktopLayout}
                mobileLayout={ContactInfoPanelMobileLayout}
                {...this.props}
                openUrl={this.openUrl} />
        )
    }
}

export default ContactInfoPanel;



// WEBPACK FOOTER //
// ./src/components/locator/details/ContactInfoPanel.js